import TdsField from "./TdsField";
import { MONTH_OPTIONS } from "../tdsReportsConfig";

export default function TdsReportsFilters({
  filters,
  onChange,
  financialYear,
  onFinancialYearChange,
  fyOptions,
  departments,
  employeeOptions,
  employeesLoading,
  regimeLabel,
  fyEditable = true,
}) {
  const set = (key, value) => onChange({ ...filters, [key]: value });

  return (
    <section className="tdsr-filters" aria-label="Report filters">
      <div className="tdsr-filters__head">
        <h3 className="tdsr-filters__title">Smart Filters</h3>
        <p className="tdsr-filters__sub">Refine the report before generation</p>
      </div>
      <div className="tdsr-filters__grid">
        <TdsField label="Payroll Month">
          <select value={filters.payrollMonth} onChange={(e) => set("payrollMonth", e.target.value)}>
            {MONTH_OPTIONS.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </TdsField>
        <TdsField label="Financial Year">
          <select
            value={financialYear}
            onChange={(e) => onFinancialYearChange?.(e.target.value)}
            disabled={!fyEditable || !onFinancialYearChange}
          >
            {fyOptions.map((fy) => (
              <option key={fy} value={fy}>
                FY {fy}
              </option>
            ))}
          </select>
        </TdsField>
        <TdsField label="Department">
          <select value={filters.department} onChange={(e) => set("department", e.target.value)}>
            <option value="">All Departments</option>
            {departments.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
        </TdsField>
        <TdsField label="Employee">
          <select
            value={filters.employeeId}
            onChange={(e) => set("employeeId", e.target.value)}
            disabled={employeesLoading}
          >
            <option value="">{employeesLoading ? "Loading…" : "All Employees"}</option>
            {employeeOptions.map((e) => (
              <option key={e.id} value={e.id}>
                {e.name}
                {e.code ? ` (${e.code})` : ""}
              </option>
            ))}
          </select>
        </TdsField>
        <TdsField label="Branch">
          <select value={filters.branch || ""} onChange={(e) => set("branch", e.target.value)}>
            <option value="">All Branches</option>
          </select>
        </TdsField>
        <TdsField label="Cost Center">
          <select value={filters.costCenter || ""} onChange={(e) => set("costCenter", e.target.value)}>
            <option value="">All Cost Centers</option>
          </select>
        </TdsField>
        <TdsField label="Employee Type">
          <select value={filters.employeeType || ""} onChange={(e) => set("employeeType", e.target.value)}>
            <option value="">All Types</option>
            <option value="permanent">Permanent</option>
            <option value="contract">Contract</option>
          </select>
        </TdsField>
        <TdsField label="Payroll Status">
          <select value={filters.payrollStatus || ""} onChange={(e) => set("payrollStatus", e.target.value)}>
            <option value="">All Statuses</option>
            <option value="processed">Processed</option>
            <option value="pending">Pending</option>
          </select>
        </TdsField>
        <TdsField label="Tax Regime">
          <select value={filters.regime} onChange={(e) => set("regime", e.target.value)}>
            <option value="">All Regimes</option>
            <option value="old">Old Regime</option>
            <option value="new">New Regime</option>
          </select>
        </TdsField>
        <TdsField label="Search Employee">
          <input
            type="search"
            placeholder="Name or employee code…"
            value={filters.search}
            onChange={(e) => set("search", e.target.value)}
          />
        </TdsField>
      </div>
      <p className="tdsr-filters__note">
        Active org regime: <strong>{regimeLabel}</strong>. Branch and cost center filters apply when
        metadata is available on employee records.
      </p>
    </section>
  );
}
